export default __webpack_public_path__ + "static/media/cxess.c2c9329d.svg";